import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { addBusinessPartner, getBusinessPartnerProfile, getBusinessPartnerStatus, getStateWiseCities, updateBusinessPartner} from "../../../services/userMasterUser";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { getUserData } from "../../../utils/localStorage";

export default function BusinessPartnerCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { userProfileData } = getUserData();

    const [stateCitiesList, setStateCitiesList] = useState([])
    const [stateCityList, setStateCityList] = useState({});
  
  const [businessPartnerProfile, setBusinessPartnerProfile] = useState([])
  const [businessPartnerStatus, setBusinessPartnerStatus] = useState([])

  const [input, setInput] = useState({
    name: state?.name || "",
    mobile: state?.mobile || "",
    emailId: state?.emailId || "",
    city: state?.city || "",
    state: state?.state || "",
    natureOfProduct: state?.natureOfProduct || "",
    natureOfService: state?.natureOfService || "",
    profile: state?.profile || "",
    status: state?.status || "",
  });

  const citiesList = stateCityList[input.state] || [];

  const [errors, setErrors] = useState({
    name: "",
    mobile: "",
    emailId: "",
    city: "",
    state: "",
    natureOfProduct: "",
    natureOfService: "",
    profile: "",
    status: "",
  });

  useEffect(() => {

    const stateCitiesData = {
          searchBy: "",
          searchText: "",
          limit: 100000,
          offset: 0,
          sortBy: "",
          sortOrder: "desc",
          cityIn: [],
          stateIn: []
        }
    
        getStateWiseCities(stateCitiesData)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
    
              // const stateList = Object.keys(Res).map((key) => ({
              //   key
              // }));
    
              const stateListArray = Object.keys(Res);
    
              const stateList = stateListArray.map((item) => ({
                label: item,
                value: item,
              }));
    
              setStateCitiesList(stateList)
    
              setStateCityList(Res)
            } else {
              errorMessage("Invalid Credentials");
            }
          })
          .catch((err) => {
            errorMessage();
          })
          .finally(() => console.log(false));
    

    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
    }
  }, [state]);

   const fetchData = () => {
  
     getBusinessPartnerProfile()
        .then((response) => {
          if (!response.data.error) {
            const newData = response.data; // adjust if API structure differs
            const newDataProfile = newData.map((item) => ({
              label: item,
              value: item,
            }));

            setBusinessPartnerProfile(newDataProfile)
            
          } else {
            errorMessage("Invalid Credentials");
          }
        })
        .catch(() => {
          errorMessage();
        })
        .finally(() => {
          console.log(false);
        });

     getBusinessPartnerStatus()
       .then((response) => {
         if (!response.data.error) {
           const newData = response.data; // adjust if API structure differs
           const newDataStatus = newData.map((item) => ({
             label: item,
             value: item,
           }));

           setBusinessPartnerStatus(newDataStatus)

         } else {
           errorMessage("Invalid Credentials");
         }
       })
       .catch(() => {
         errorMessage();
       })
       .finally(() => {
         console.log(false);
       });
    };

  useEffect(() => {
    fetchData()
  }, [])
  



  const [statusData, setStatusData] = useState([
    { label: "ACTIVE", value: "ACTIVE" },
    { label: "INACTIVE", value: "INACTIVE" }
  ]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;

    if (!(input.name)) {
      newErrors.name = "Please Enter Name";
      isValid = false;
    } else {
      newErrors.name = "";
    }



    if (input.mobile === "") {
      newErrors.mobile = "Please Enter Mobile";
      isValid = false;
    } else {
      newErrors.mobile = "";
    }

    if (input.emailId === "") {
      newErrors.emailId = "Please Enter Email Id";
      isValid = false;
    } else {
      newErrors.emailId = "";
    }

    
    if (input.city === "") {
      newErrors.city = "Please Enter City";
      isValid = false;
    } else {
      newErrors.city = "";
    }
    
    if (input.state === "") {
      newErrors.state = "Please Enter State";
      isValid = false;
    } else {
      newErrors.state = "";
    }
    
    if (input.natureOfProduct === "") {
      newErrors.natureOfProduct = "Please Enter Nature Of Product";
      isValid = false;
    } else {
      newErrors.natureOfProduct = "";
    }
    
    if (input.natureOfService === "") {
      newErrors.natureOfService = "Please Enter Nature Of Service";
      isValid = false;
    } else {
      newErrors.natureOfService = "";
    }
    
    if (input.profile === "") {
      newErrors.profile = "Please Enter Profile";
      isValid = false;
    } else {
      newErrors.profile = "";
    }
    
    if (input.status === "") {
      newErrors.status = "Please Enter Status";
      isValid = false;
    } else {
      newErrors.status = "";
    }

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          id: state?.id,
          name: input.name,
          mobile: input.mobile,
          emailId: input.emailId,
          city: input.city,
          state: input.state,
          natureOfProduct: input.natureOfProduct,
          natureOfService: input.natureOfService,
          profile: input.profile,
          status: input.status,
        };
        updateBusinessPartner(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                if(userProfileData?.role !== "ROLE_BUSINESS_PARTNER_HANDLER") {
                  navigate("/user-master/business-partner/list");
                } else {
                  navigate("/")
                }
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          name: input.name,
          mobile: input.mobile,
          emailId: input.emailId,
          city: input.city,
          state: input.state,
          natureOfProduct: input.natureOfProduct,
          natureOfService: input.natureOfService,
          profile: input.profile,
          status: input.status,
        };
        addBusinessPartner(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                if (userProfileData?.role !== "ROLE_BUSINESS_PARTNER_HANDLER") {
                  navigate("/user-master/business-partner/list");
                } else {
                  navigate("/")
                }
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  {userProfileData?.role !== "ROLE_BUSINESS_PARTNER_HANDLER" ? <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/business-partner/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div>
                    : <div
                      className="mr-3 cursor-pointer"
                      onClick={() => navigate("/")}
                    >
                      <i class="bi bi-arrow-left-circle-fill"></i>
                    </div>
                }
                  Business Partner {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Name
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="name"
                        name="Name"
                        value={input.name}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            name: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.name}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Mobile
                      </label>
                      <InputText
                        type="tel"
                        style={{ width: "100%" }}
                        id="mobile"
                        name="Mobile"
                        value={input.mobile}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            mobile: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.mobile}</div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Email Id
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="emailId"
                        name="Email Id"
                        value={input.emailId}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            emailId: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.emailId}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        State
                      </label>
                       <Dropdown
                          style={{ width: "100%" }}
                          value={input.state}
                          onChange={(e) =>
                            setInput({ ...input, state: e.target.value })
                          }
                          options={stateCitiesList}
                          optionLabel="label"
                          placeholder="Select a State"
                          filter
                          filterDelay={400}
                        />
                      <div className="text-danger">{errors.state}</div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        City
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        value={input.city}
                        onChange={(e) =>
                          setInput({ ...input, city: e.target.value })
                        }
                        options={citiesList}

                        placeholder="Select a City"
                        filter
                        filterDelay={400}
                      />
                      <div className="text-danger">{errors.city}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Nature Of Product
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="natureOfProduct"
                        name="Nature Of Product"
                        value={input.natureOfProduct}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            natureOfProduct: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.natureOfProduct}</div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Nature Of Service
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="natureOfService"
                        name="Nature Of Service"
                        value={input.natureOfService}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            natureOfService: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.natureOfService}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Profile
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={businessPartnerProfile}
                        value={input.profile}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            profile: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.profile}</div>
                    </div>
                  </div>

                   <div className="row mb-3">
                     
                    <div className="col-md-12">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={businessPartnerStatus}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>
                  </div>
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
